<template>
    <div class="row">
        <div class="col-12">
            <ibox
                :title="'Produkty'"
            >
                <template
                    slot="content"
                    slot-scope="{ setLoading }"
                >
                    <data-tables
                        url="pl/neonail/gift-cards/list"
                        :columns_list="columns_list"
                        :rowStyle="rowStyle"
                        @loading="setLoading"
                    />
                </template>
            </ibox>
        </div>
    </div>
</template>

<script>
import Ibox from '@/components/Ibox'
import DataTables from '@/components/DataTables'
import { php } from 'locutus'

export default {
    name: 'NNPLGiftCards',
    components: {
        Ibox,
        DataTables
    },
    data() {
        return {
            columns_list: [
                {
                    key: 'id',
                    name: 'Wysłany',
                    filter: 'btn',
                    touch: true,
                    function: a  => {
                        this.$http.put( `pl/neonail/gift-cards/${ a }/tauch` )
                            .then( () => {
                                this.$toastr.success( 'ok' )
                                this.$emit( 'forceUpdate' )
                            } )
                            .catch( () => {
                                this.$toastr.error( ':(' )
                            } )
                    },
                    btn: ( a, d ) => {
                        if ( d.updated_at === d.created_at ) {
                            return '<div class="btn btn-primary"><i class="fa fa-check"></i></a>'
                        } else {
                            return ''
                        }
                    }
                },
                {
                    key: 'Code',
                    name: 'Kod',
                    type: 'text',
                    sortable: true
                },
                {
                    key: 'prod_id',
                    name: 'Kwota',
                    filter: 'function',
                    col_function: prodId => {
                        switch ( prodId ) {
                            case 17839:
                                return '50.00'
                            case 17840:
                                return '100.00'
                            case 17841:
                                return '200.00'
                            default:
                                return '???'
                        }
                    }
                },
                {
                    key: 'order_customer',
                    name: 'Imię i nazwisko',
                    filter: 'function',
                    col_function: a => {
                        if ( a ) {
                            const unserializedData = php.var.unserialize( a )
                            return `<p>
                                        <strong>${unserializedData.name} ${unserializedData.surname}</strong>
                                    </p>`
                        }
                    }
                },
                {
                    key: 'expDate',
                    name: 'Data ważności',
                    type: 'date',
                    sortable: true
                },
                {
                    key: 'order_num',
                    name: 'Nr Zamówienia',
                    type: 'text',
                    sortable: true
                },
                {
                    key: 'order_date',
                    name: 'Data zamówienia',
                    type: 'date',
                    sortable: true
                },
                {
                    key: 'created_at',
                    name: 'Utworzone',
                    type: 'date',
                    sortable: true
                }
            ]
        }
    },
    methods: {
        rowStyle( data ) {
            console.log( data )
            if ( data.updated_at === data.created_at ) {
                return 'background-color: #ffeeba; color: #000;'
            } else {
                return 'background-color: #8fd19e; color: #000;'
            }
        }
    }
}
</script>
